import {markNotificationSourcesRead} from "../../../../_common/notificationRead";
import React, {useEffect, useState} from "react";
import {Button, Card, Tabs, Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import AnnouncementListing_2 from "./component/announcementListing";
import {getUserAnnouncementByUserId, updateUserAnnouncementReadStatus} from "../../../../api/graphql/announcement";
import {
    globalNotificationState,
    globalUnreadAnnouncementCountState,
    globalUnreadPushNotificationCountState
} from "../../../../_common/global_state";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import "./css/style.css"
import PushNotificationListing_2 from "./component/pushNotificationListing";
import {
    getPushNotificationLogByUserId,
    updatePushNotificationLogReadStatus
} from "../../../../api/graphql/pushNotification";
import {useGetHeaderPushNotificationLogByUserId} from "../../function";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const Announcement_2 = (props) => {
    const {isHeader} = props
    const { t } = useTranslation();
    const setNotificationMessage = useSetRecoilState(globalNotificationState);
    const [unreadAnnouncementCount, setUnreadAnnouncementCount] = useRecoilState(globalUnreadAnnouncementCountState);
    const unreadPushNotificationCount = useRecoilValue(globalUnreadPushNotificationCountState);
    const [loading, setLoading] = useState(true)
    const [announcementTotal, setAnnouncementTotal] = useState(0)
    const [announcementData, setAnnouncementData] = useState([]);
    const [markingAllAsRead, setMarkingAllAsRead] = useState(false)

    const [, , fetchPushNotificationLog] = useGetHeaderPushNotificationLogByUserId()

    const userId = localStorage.getItem("userid")

    // the two lists on screen hold only the first 8 records each, so the ids to mark are
    // fetched fresh instead of read off the rendered lists

    const unreadTotal = (unreadAnnouncementCount || 0) + (unreadPushNotificationCount || 0)

    const preload = async (offset = 0) => {
        try {
            setLoading(true)
            const responseAnnouncement = await getUserAnnouncementByUserId(userId, 8, offset);
            const page = responseAnnouncement?.getUserAnnouncementByUserId;
            if (!Array.isArray(page?.data) || page.errKey) throw new Error("Could not load announcements");
            setAnnouncementData(previous => offset ? [...new Map([...previous, ...page.data].map(item => [item._id, item])).values()] : page.data);
            setUnreadAnnouncementCount(responseAnnouncement?.getUserAnnouncementByUserId?.unreadTotal);
            setAnnouncementTotal(responseAnnouncement?.getUserAnnouncementByUserId?.total);
        } catch (e) {
            setLoading(false);
            setNotificationMessage({
                status: "error",
                title: "",
                msg: "Apologies, we are currently undergoing maintenance for the announcement page. We're actively working to resolve the issue.",
                key: "systemNotification",
            });
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        preload()
        fetchPushNotificationLog()
    }, [])

    const markAllAsRead = async () => {
        try {
            setMarkingAllAsRead(true)

            await markNotificationSourcesRead([
                {fetchPage: getUserAnnouncementByUserId, listField: "getUserAnnouncementByUserId", update: updateUserAnnouncementReadStatus, updateField: "updateUserAnnouncementReadStatus"},
                {fetchPage: getPushNotificationLogByUserId, listField: "getPushNotificationLogByUserId", update: updatePushNotificationLogReadStatus, updateField: "updatePushNotificationLogReadStatus"},
            ], userId)
        } catch (e) {
            setNotificationMessage({
                status: "error",
                title: "",
                msg: t("announcement.markAllAsReadFailed", {defaultValue: "Could not mark everything as read. Please try again."}),
                key: "systemNotification",
            });
        } finally {
            await Promise.allSettled([preload(), fetchPushNotificationLog()]);
            setMarkingAllAsRead(false)
        }
    }

    const items = [
        {
            key: "1",
            label: "Announcement",
            children: <><AnnouncementListing_2
                loading={loading}
                isHeader={isHeader}
                data={announcementData}
                total={announcementTotal}
            />{announcementData?.length < announcementTotal && <Button loading={loading} onClick={() => preload(announcementData.length)}>{t("common.loadMore", {defaultValue:"Load more"})}</Button>}</>,
        },
        {
            key: "2",
            label: "Push Notification",
            children: <PushNotificationListing_2
                isHeader={isHeader}
            />,
        },
    ];

    return (
        <div id={"announcement"}>
            <Card>
                <Tabs
                    defaultActiveKey="1"
                    items={items}
                    centered
                    tabBarExtraContent={unreadTotal > 0 && (
                        <Tooltip title={t("announcement.markAllAsRead", {defaultValue: "Mark all as read"})}>
                            <Button
                                size={"small"}
                                className={"mark-all-as-read"}
                                loading={markingAllAsRead}
                                onClick={markAllAsRead}
                                aria-label={t("announcement.markAllAsRead", {defaultValue: "Mark all as read"})}
                                icon={<FontAwesomeIcon icon={faCheckDouble}/>}
                            />
                        </Tooltip>
                    )}
                />
            </Card>
        </div>
    )
}

export default Announcement_2